/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_TitleInputs */

const cs_share_title = /** @type {(inputs: Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílené dokumenty`)
};

const en_share_title = /** @type {(inputs: Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared documents`)
};

/**
* | output |
* | --- |
* | "Shared documents" |
*
* @param {Share_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const share_title = /** @type {((inputs?: Share_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_title(inputs)
	return cs_share_title(inputs)
});